import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20sunlight%20filtering%20through%20a%20beautiful%20pear%20orchard%20with%20ripe%20golden%20pears%20hanging%20from%20branches%2C%20soft%20dreamy%20bokeh%20background%2C%20artistic%20landscape%20photography%2C%20warm%20amber%20and%20soft%20green%20tones%2C%20ethereal%20morning%20light%2C%20shallow%20depth%20of%20field%2C%20pastoral%20aesthetic%2C%20natural%20organic%20composition%2C%20elevated%20food%20photography%20style&width=1800&height=900&seq=hero-pear-orchard&orientation=landscape"
          alt="惠美梨果园 - 品质优选"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full h-full flex items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs md:text-sm font-medium mb-6 border border-background-50/20">
            {heroData.subtitle}
          </span>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 tracking-tight">
            {heroData.title}
          </h1>
          <p className="text-base md:text-lg text-background-100/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            {heroData.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to={heroData.ctaLink}
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {heroData.ctaText}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to={heroData.secondaryCtaLink}
              className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm md:text-base border border-background-50/30 hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap"
            >
              {heroData.secondaryCtaText}
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/40 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}